export default __webpack_public_path__ + "static/media/a011-07.66fa19b2.jpg";